<template>
  <ubi-panel>
    <ubi-list-header slot="header"
                     :limits="limits"
                     :total="socialPostsBiensVendus.total"
                     :page.sync="page"
                     :limit.sync="limit"></ubi-list-header>
    <template slot="actions">
      <div v-if="!selected.length">
        <!--        <el-button icon="export" size="mini" v-if="!selected.length" @click="exporter()">-->
        <!--          {{ $t("general.selection.exportAll") }}-->
        <!--        </el-button>-->
      </div>
      <div v-else>
          <span>
<!--              <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) : {{ (' ') }}</span>-->
            <!--                        <el-button class="PostsList-export" size="mini" style="margin-left: 5px"-->
            <!--                                   @click="exporter(selected)">{{ $t("general.selection.export") }}</el-button>-->
              <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) : {{ (' ') }}</span>
                        <el-button class="PostsList-delete" size="mini" style="margin-left: 5px"
                                   @click="deletePost(selected)">{{ $t("general.selection.remove") }}</el-button>
          </span>
      </div>
    </template>
    <ubi-list-footer
        slot="footer"
        v-if="socialPostsBiensVendus.total && socialPostsBiensVendus.total > 1"
        :limits="limits"
        :total="socialPostsBiensVendus.total"
        :page.sync="page"
        :limit.sync="limit"
    ></ubi-list-footer>

    <!-- Sticker View => CardList-->
    <SocialPostCard
        :selected="selected"
        :socialPosts="socialPostsBiensVendus"
        :loadingStatus="loadingStatus"
        type="BiensVendus"
        @update:selected="selected = $event"
    ></SocialPostCard>

    <el-table ref="table"
              v-if="socialPostsBiensVendus && isListView"
              :data="socialPostsBiensVendus.list"
              v-loading="loadingStatus"
              @select="selectedChanged"
              @select-all="selectAllChanged"
    >

      <el-table-column
          type="selection"
          width="55">
      </el-table-column>

      <el-table-column label="Publication" width="430">
        <template v-slot="{ row: result }">
          <el-row>
            <el-col :lg="4">
              <div v-if="result.photoPrincipale !== false">
                <img width="60"
                     alt=""
                     :src="result.photoPrincipale.url_miniature"
                     :srcset="result.photoPrincipale.url_miniature"
                />
              </div>
              <div v-else style="text-align: center;">
                <ubi-icon class="no-photo" name="camera" size='60'/>
              </div>
            </el-col>
            <el-col :lg="18">
              <div>{{ result.reference }}<br> {{ result.titre }}</div>
            </el-col>
          </el-row>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishOn')" width="100">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence-icons :post="result"></social-posts-list-table-presence-icons>
        </template>
      </el-table-column>

      <el-table-column :label="$t('socialPosts.list.publishedOn')" width="350">
        <template v-slot="{ row: result }">
          <social-posts-list-table-presence :post="result"></social-posts-list-table-presence>
        </template>
      </el-table-column>

      <el-table-column fixed="right" :label="$t('socialPosts.list.actions')" width="75">
        <template v-slot="{ row: result }">
          <div>
            <em class="el-icon-edit-outline" @click="editPost(result.id)" style="margin-right: 10px;"></em>
            <em class="el-icon-delete" @click="deleteModalShow(result)" v-if="checkNbDiffusionsActives(result) > 0"></em>

          </div>
        </template>
      </el-table-column>
    </el-table>

  </ubi-panel>
</template>

<script>

import SocialPostsListTablePresence from './SocialPostsListTablePresence'
import SocialPostsListTablePresenceIcons from '@/pages/socialNetworks/Blocks/SocialPostsListTablePresenceIcons'
import {mapGetters, mapMutations, mapState} from 'vuex'
import UbiListFooter from "@/components/lists/ListFooter.vue";
import UbiListHeader from "@/components/lists/ListHeader.vue";
import UbiPanel from "@/components/Panel.vue";
import UbiIcon from "@/components/Icon.vue";
import SocialPostCard from "@/components/ui/SocialPostCard.vue";

export default {
  name: 'SocialPostsTableBiensVendus',
  components: {
    SocialPostCard,
    UbiIcon,
    UbiPanel,
    UbiListHeader,
    UbiListFooter,
    SocialPostsListTablePresence,
    SocialPostsListTablePresenceIcons
  },
  data () {
    return {
      limits: [5, 10, 20],
      loading: false,
      selected: []
    }
  },
  props: ['selectedPostsBV'],
  watch: {
    selectedPostsBV: function (val) {
      this.selected = []
    }
  },
  computed: {
    ...mapState('socialPostsTableBiensVendus', ['filters', 'socialPostsBiensVendus', 'loadingStatus']),
    ...mapGetters('socialNetworkPosts', ['getView', 'isListView']),
    page: {
      get () {
        return this.filters.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
      }
    },
    limit: {
      get () {
        return this.filters.limit
      },
      set (value) {
        this.setLimit(value)
        this.setPage(1)
        this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
      }
    }
  },
  mounted () {
    this.$store.dispatch('socialPostsTableBiensVendus/loadSocialPostsBiensVendus')
  },
  methods: {
    ...mapMutations('socialPostsTableBiensVendus', [
      'setPage',
      'setSocialPostsBiensVendus',
      'setLimit'
    ]),
    deletePost (selected) {
      this.$store.commit('socialPostsTableBiensVendus/setPostToDelete', selected)
      this.$store.commit('socialPostsTableBiensVendus/checkDiffusionsPostsToDelete')
      this.$store.commit('socialPostsTableBiensVendus/setModalDelete', true)
    },
    deleteModalShow (post) {
      console.log(post)
      this.$store.commit('socialPostsTableBiensVendus/setModalDelete', true)
      this.$store.commit('socialPostsTableBiensVendus/setPostToDelete', [post])
    },
    editPost (id) {
      this.$router.push({ name: 'edit-bien-vendu', params: { id: id } })
    },
    async doSelect (type) {
      if (type === '*') {
        this.selected = []
        const tmpSelection = this.socialPostsBiensVendus.list
        this.selected = tmpSelection
      }
      if (type === null) {
        this.selected = []
      }
    },
    selectAllChanged (selection) {
      // unselect all case
      if (!selection.length) {
        this.selected = []
        const self = this
        this.socialPostsBiensVendus.list.forEach(function (item) {
          const index = self.selected.indexOf(item)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }, self)
      } else { // select all case
        this.doSelect('*')
      }
    },
    checkNbDiffusionsEnvoyees (post) {
      let nbEnvoyees = 0
      if (post.diffusions.length > 0) {
        post.diffusions.forEach(function (element) {
          if (element.firstSentAt) {
            return 0
          }
        })
      }
      if (post.planifications) {
        post.planifications.forEach(function (element) {
          if (element.scheduled) {
            nbEnvoyees = nbEnvoyees + 1
          }
        })
      }
      return nbEnvoyees
    },
    checkNbDiffusionsActives (post) {
      let nbEnvoyees = 0
      let found = 0

      if (post.diffusions && post.diffusions.length > 0) {
        post.diffusions.forEach(function (element) {
          if (element.firstSentAt === null) {
            nbEnvoyees = nbEnvoyees + 1
          } else {
            found = 1
          }
        })
      }
      if(found === 1) {
        nbEnvoyees = 0
      }
      if(post.diffusions.length === 0 && post.planifications) {
        nbEnvoyees = 1
      }
      if (!post.planifications) {
        nbEnvoyees = 0
      }
      return nbEnvoyees
    },
    selectedChanged (selection, row) {
      let add = false
      selection.forEach(function (item) {
        if (item.id === row.id) {
          add = true
        }
      })

      const index = this.selected.indexOf(row)

      if (add) {
        if (index === -1) {
          this.selected.push(row)
        }
      } else {
        if (index > -1) {
          this.selected = selection
        }
      }
    }
  }

}
</script>
<style scoped>

em.el-icon-delete:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
em.el-icon-edit-outline:hover {
  color: #d24554 !important;
  font-weight: bold;
  cursor: pointer;
}
</style>
